import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatchEvent } from '../../../models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'adjust-row-timings-dialog',
  templateUrl: './adjust-row-timings-dialog.html',
  styleUrls: ['./adjust-row-timings-dialog.css']
})
export class AdjustRowTimingsDialog implements OnInit {
  propertiesFormGroup: FormGroup;

  secondsAdjustment = 0;
  leadSecondsAdjustment = 0;
  lagSecondsAdjustment = 0;

  constructor(
    private _fb: FormBuilder,
    public dialogRef: MatDialogRef<AdjustRowTimingsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: MatchEvent[]
  ) {}

  ngOnInit(): void {
    console.info('Adjusting timings: ', this.data);
    // this.propertiesFormGroup = this._fb.group(this.data.properties);
  }

  onSaveClick() {
    const adjustedEvents = this.data.map(e => {
      const seconds = (e.seconds += this.secondsAdjustment);
      const leadSeconds = (e.leadSeconds += this.leadSecondsAdjustment);
      const lagSeconds = (e.lagSeconds += this.lagSecondsAdjustment);

      const codeEvent = { ...e, seconds, leadSeconds, lagSeconds };

      return codeEvent;
    });

    this.dialogRef.close(adjustedEvents);
  }
}
